import React from 'react';
import { Typography } from 'fronton-react';
import { styled } from 'linaria/react';
import { WarningIcon } from '@fronton/icons-react';
import { useTranslation } from 'react-i18next';

export const WarningSnackBar = () => {
  const { t } = useTranslation();

  return (
    <WarningBarContainer>
      <ParagraphContainer>
        <WarningIcon type="outline" size="l" color="text-primary" />
        <Typography size="body_long" variant="s">
          {t('calculator.dimensions.warning')}
        </Typography>
      </ParagraphContainer>
    </WarningBarContainer>
  );
};

const WarningBarContainer = styled.div`
  display: flex;
  padding: 16px;
  margin-top: var(--space-350);
  background: var(--attention-light);
  border-radius: var(--rounding-l);
`;

const ParagraphContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    font-size: 14px !important;
  }
`;
